import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import Avatar from '@material-ui/core/Avatar'
import Box from '@material-ui/core/Box'
import LockIcon from '@material-ui/icons/Lock'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import AdapterLink from 'utils/AdapterLink'
import LoginForm from 'components/login/LoginForm'
import useGlobal from 'hooks/useGlobal'

const useStyles = makeStyles(theme => ({
	paper: {
		padding: theme.spacing(3),
		[theme.breakpoints.up('md')]: {
			marginTop: theme.spacing(6),
			marginBottom: theme.spacing(6),
		},
		[theme.breakpoints.down('sm')]: {
			marginTop: theme.spacing(2),
			marginBottom: theme.spacing(2),
		},
	},
	avatar: {
		background: 'linear-gradient(135deg, #FAB2FF 10%, #1904E5 100%)',
		margin: `0 auto ${theme.spacing(2)}px`,
	},
	goback: {
		marginLeft: theme.spacing(-2),
		marginTop: theme.spacing(-2),
	},
}))

function Login() {
	const classes = useStyles()

	const [config] = useGlobal(state => state.config)

	useEffect(() => {
		document.title = `${config.wc_title} | 로그인`
	}, [config.wc_title])

	return (
		<Container maxWidth="sm">
			<Paper className={classes.paper}>
				<IconButton component={AdapterLink} to="/" aria-label="goback" classes={{ root: classes.goback }}>
					<ArrowBackIcon />
				</IconButton>
				<Box textAlign="center">
					<Avatar className={classes.avatar}>
						<LockIcon />
					</Avatar>
					<Typography gutterBottom variant="h6" component="h2">
						관리자 로그인
					</Typography>
				</Box>
				<LoginForm />
			</Paper>
		</Container>
	)
}

export default Login
